'use client';
import React, { useState } from 'react';
import classnames from 'classnames';
import Link from 'next/link';
import AOS from 'aos';
import useScrollDirection from '../../utils/hooks/useScrollDirection';
import LinkButton from '../LinkButton';
import MobileMenu from './Menu';
import 'aos/dist/aos.css';
import s from './Header.module.scss';
import BrandLogo from './logo-black.svg';

// Define interfaces for props and state
interface HeaderProps {
  currentPage: string;
  layoutStyle?: React.CSSProperties;
}

interface ScrollDirectionState {
  scrollDirection: 'up' | 'down' | null;
  prevScrollTop: number;
}

const canUseDOM = typeof window !== 'undefined' && window.document;

if (canUseDOM) {
  AOS.init({
    offset: 10,
    duration: 500,
    once: true,
  });
}

export default function Header({
  currentPage,
  layoutStyle = {},
}: HeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const { scrollDirection, prevScrollTop }: ScrollDirectionState = useScrollDirection();

  const handleModalOpen = (): void => {
    setIsMenuOpen(true);
  };

  const handleModalClose = (): void => {
    setIsMenuOpen(false);
  };
  return (
    <header
      id="root"
      style={layoutStyle}
      className={classnames(s.root, {
        [s.transparentBG]: prevScrollTop <= 10,
        [s.hiddenHeader]: scrollDirection === 'down',
      })}
    >
      <div className={s.container}>
        <div className={s.left}>
          <Link aria-label="Home" href="/">
            <BrandLogo className={s.logo} data-testid="HeaderBrandLogo" />
          </Link>
        </div>
        <div className={s.right}>
          <LinkButton className={[s.navButton, currentPage === '/about' ? s.selected : ''].filter(Boolean).join(' ')} href="/about">
            About Us
          </LinkButton>
          <LinkButton className={[s.navButton, currentPage.includes('/services') ? s.selected : ''].filter(Boolean).join(' ')} href="/services">
            What We Do
          </LinkButton>
          <LinkButton
            className={[s.navButton, currentPage === '/work' || currentPage.includes('/casestudy') ? s.selected : ''].filter(Boolean).join(' ')}
            href="/work"
          >
            Case Studies
          </LinkButton>
          <LinkButton
            className={[s.navButton, s.blog, currentPage === '/blog' ? s.selected : ''].filter(Boolean).join(' ')}
            href="/blog"
          >
            Blog
          </LinkButton>
          <LinkButton className={[s.navButton, currentPage.includes('/careers') ? s.selected : ''].filter(Boolean).join(' ')} href="/careers">
            Careers
          </LinkButton>
          <LinkButton className={[s.navButton, s.contact].join(' ')} href="/contact">
            Contact Us
          </LinkButton>
          <button
            className={s.hamburger}
            type="button"
            tabIndex={0}
            onKeyPress={handleModalOpen}
            onClick={handleModalOpen}
            aria-label="Open the menu"
          />
        </div>
      </div>
      <MobileMenu
        isOpen={isMenuOpen}
        currentPage={currentPage}
        onModalClose={handleModalClose}
      />
    </header>
  );
}
